import { render, staticRenderFns } from "./blog-list.vue?vue&type=template&id=37fc7a54"
import script from "./blog-list.vue?vue&type=script&lang=ts"
export * from "./blog-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports